"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.VisualizationContainerSwitch = exports.VisualizationContainer = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssElementQueries = require("css-element-queries");
var _VisualizationProvider = require("./VisualizationProvider");
var _VisualizationInterface = require("./VisualizationInterface");
var _AlignTargetProvider = require("./AlignTargetProvider");
var _updateFitSizeToElement = require("./Utils/updateFitSizeToElement");
var _Constants = require("./Constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var didBoundingRectChange = function () {
  var prevRect;
  return function (element) {
    var rect = element.getBoundingClientRect();
    if (!rect.width || !rect.height) {
      return false;
    }
    var result = !prevRect || ["top", "bottom", "left", "right"].some(function (key) {
      return rect[key] !== prevRect[key];
    });
    prevRect = rect;
    return result;
  };
}();
var defaultContainerStyle = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  overflow: "hidden"
};

/**
 * Component for the Three.js visualization
 * Responsibilities:
 *  - renders the placeholder for the THREE.js visualization
 *  - adds the Three instance to the placeholder, initializes the controls
 *  - loads the current model and starts the animation
 *  - will handle probably the positioning of the 3D component
 */
var VisualizationContainer = exports.VisualizationContainer = /*#__PURE__*/function (_React$Component) {
  _inherits(VisualizationContainer, _React$Component);
  var _super = _createSuper(VisualizationContainer);
  function VisualizationContainer() {
    var _this;
    _classCallCheck(this, VisualizationContainer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      loading: false,
      broken: false
    });
    _defineProperty(_assertThisInitialized(_this), "setLoading", function (loading) {
      _this.setState({
        loading: loading
      });
    });
    _defineProperty(_assertThisInitialized(_this), "doAlignment", function () {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _options$animate = options.animate,
        animate = _options$animate === void 0 ? false : _options$animate;
      var _this$props = _this.props,
        visualization = _this$props.visualization,
        alignTargetElement = _this$props.alignTargetElement;
      if (!alignTargetElement) {
        return;
      }
      var _alignTargetElement$g = alignTargetElement.getBoundingClientRect(),
        width = _alignTargetElement$g.width,
        height = _alignTargetElement$g.height;
      if (!width || !height) {
        return;
      }
      (0, _updateFitSizeToElement.updateFitSizeToElement)(visualization, alignTargetElement).updateCameraPosition({
        animate: visualization.isAnimating() || animate
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onSizeChange", function (size) {
      var _this$props2 = _this.props,
        visualization = _this$props2.visualization,
        alignTargetElement = _this$props2.alignTargetElement;
      if (!visualization.isInitialized()) {
        return;
      }
      visualization.setSize(size);
      if (alignTargetElement && alignTargetElement.clientWidth > 0 && alignTargetElement.clientHeight > 0) {
        _this.doAlignment({
          animate: true
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "containerRef", /*#__PURE__*/_react["default"].createRef());
    return _this;
  }
  _createClass(VisualizationContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var visualization = this.props.visualization;
      if (!visualization) {
        // eslint-disable-next-line no-console
        console.warn("Visualization component is not provided! Visualization will not be rendered.");
        return;
      }
      if (!(visualization instanceof _VisualizationInterface.VisualizationInterface)) {
        throw new Error('The provided "three" prop should always be a subclass of VisualizationInterface!');
      }
      this.initResizeSensor();
      this.updateVisualization({}, {
        animate: false
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.updateVisualization(prevProps, {
        animate: true
      });
    }
  }, {
    key: "initResizeSensor",
    value: function initResizeSensor() {
      var container = this.containerRef.current;
      this.resizeSensor = new _cssElementQueries.ResizeSensor(container, this.onSizeChange);
    }
  }, {
    key: "initMutationObserver",
    value: function initMutationObserver(prevProps) {
      var _this2 = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        animate: true
      };
      if (this.mutationObserver) {
        this.mutationObserver.disconnect();
      }
      var alignTargetElement = this.props.alignTargetElement;
      if (!alignTargetElement) {
        return;
      }
      if (alignTargetElement !== prevProps.alignTargetElement) {
        this.mutationObserver = new MutationObserver(function () {
          _this2.doAlignment(options);
        });
        // do the update only when attributes have changed (e.g. style)
        this.mutationObserver.observe(alignTargetElement, {
          attributes: true
        });
      }
      if (didBoundingRectChange(alignTargetElement)) {
        this.doAlignment(options);
      }
    }
  }, {
    key: "updateVisualization",
    value: function updateVisualization() {
      var prevProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var visualization = this.props.visualization;
      var container = this.containerRef.current;
      if (visualization !== prevProps.visualization) {
        if (prevProps.visualization) {
          prevProps.visualization.dispose();
        }
        if (visualization.isInitialized()) {
          // Three is already initialized, just add it to the current container instead of reloading it completely
          visualization.addToContainer(container);
        } else {
          this.initVisualization(container);
        }
        // init resize sensor if it's not done in the componentDidUpdate
        !this.resizeSensor && this.initResizeSensor();
      }
      this.initMutationObserver(prevProps, options);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props3 = this.props,
        autoDispose = _this$props3.autoDispose,
        visualization = _this$props3.visualization;
      autoDispose && visualization.dispose();
      this.resizeSensor && this.resizeSensor.detach();
      this.offObservers && this.offObservers();
    }
  }, {
    key: "initVisualization",
    value: function initVisualization(container) {
      var _this3 = this;
      var visualization = this.props.visualization;
      visualization.init(container);
      var offLoadError = visualization.observable.on(_Constants.EventTypes.LoadError, function (_ref) {
        var screenshot = _ref.data.screenshot;
        return !screenshot && _this3.setState({
          broken: true
        });
      });
      var offLoadFinished = visualization.observable.on(_Constants.EventTypes.LoadFinished, function (_ref2) {
        var screenshot = _ref2.data.screenshot;
        return !screenshot && _this3.setState({
          broken: false
        });
      });
      this.offObservers = function () {
        offLoadError();
        offLoadFinished();
        delete _this3.offObservers;
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        className = _this$props4.className,
        ProgressComponent = _this$props4.ProgressComponent,
        BrokenComponent = _this$props4.BrokenComponent;
      var broken = this.state.broken;
      var style = _objectSpread(_objectSpread({}, className ? {} : defaultContainerStyle), broken && BrokenComponent && {
        display: "none"
      });
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(ProgressComponent, {
        loading: this.props.isLoading
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(className || ""),
        style: style,
        ref: this.containerRef
      }), broken && BrokenComponent && /*#__PURE__*/_react["default"].createElement(BrokenComponent, null));
    }
  }]);
  return VisualizationContainer;
}(_react["default"].Component);
_defineProperty(VisualizationContainer, "propTypes", {
  visualization: _propTypes["default"].instanceOf(_VisualizationInterface.VisualizationInterface).isRequired,
  autoDispose: _propTypes["default"].bool,
  alignTargetElement: _propTypes["default"].instanceOf(Element)
});
_defineProperty(VisualizationContainer, "defaultProps", {
  ProgressComponent: function ProgressComponent(_ref3) {
    var loading = _ref3.loading;
    return loading ? /*#__PURE__*/_react["default"].createElement("div", null, "Loading component...") : null;
  },
  autoDispose: false,
  alignTargetElement: null
});
var VisualizationContainerSwitch = exports.VisualizationContainerSwitch = function VisualizationContainerSwitch(props) {
  // eslint-disable-next-line react/prop-types
  var visualization = props.visualization,
    VisualizationContainerComponent = props.VisualizationContainerComponent,
    FallbackComponent = props.FallbackComponent;
  var Component = visualization ? VisualizationContainerComponent : FallbackComponent;
  return /*#__PURE__*/_react["default"].createElement(Component, props);
};
VisualizationContainerSwitch.defaultProps = {
  VisualizationContainerComponent: VisualizationContainer,
  FallbackComponent: function FallbackComponent() {
    return null;
  }
};
var _default = exports["default"] = (0, _AlignTargetProvider.withCurrentTarget)((0, _VisualizationProvider.withVisualization)(VisualizationContainerSwitch));